import React from "react";

function BuketsTable_Jupiter(props) {
  let { data } = props;
  // console.log("dataaaaaa", data[0].Range.values["50.0"]);

  return (
    <>
      {data.length == 0
        ? "<tr><td colSpan={2}>No data found</td></tr>"
        : data.map((x, index) => {
            return (
              <tr key={x.key}>
                <td scope="row ">{x.key.vehicleId}</td>
                <td>
                  {x.Range.values["50.0"] !== null
                    ? x.Range.values["50.0"].toFixed(2)
                    : "NA"}{" "}
                </td>
              </tr>
            );
          })}
    </>
  );
}

export default BuketsTable_Jupiter;
